export default __webpack_public_path__ + "static/media/hipSagittalMovement.5cf256b2.png";